{
  "page": {
    "title": "Section settings",
    "loading": "Loading…",
    "loadError": "Could not load the section",
    "folderError": "Could not load the folder document",
    "notFound": "The section was not found or has been deleted",
    "retry": "Try again"
  },
  "mode": {
    "label": "Section mode",
    "drawing": "Drawing",
    "3d": "3D"
  },
  "actions": {
    "preview": "Preview",
    "save": "Save",
    "saveHint": "Save (Ctrl+S)",
    "cancel": "Cancel",
    "delete": "Delete"
  },
  "save": {
    "success": "Saved",
    "successHint": "The changes are visible to all users",
    "error": "Could not save",
    "errorHint": "Check the connection and try again"
  },
  "conflict": {
    "title": "The page was changed by another user",
    "text": "A newer version of the document was saved. Load it or overwrite it with your changes.",
    "textBy": "{{name}} saved a newer version at {{time}}. Load it or overwrite it with your changes.",
    "reload": "Reload",
    "overwrite": "Overwrite",
    "cancel": "Cancel",
    "reloaded": "The latest version of the document was loaded"
  },
  "guard": {
    "title": "You have unsaved changes. Leave?",
    "text": "If you leave without saving, your changes will be lost.",
    "stay": "Cancel",
    "discard": "Leave without saving",
    "save": "Save"
  },
  "panel": {
    "close": "Close",
    "drag": "Drag to move"
  },
  "slider": {
    "decrease": "decrease",
    "increase": "increase"
  },
  "folders": {
    "label": "Folders",
    "add": "Add",
    "createTitle": "Add a new modification",
    "renameTitle": "Edit modification",
    "subtitle": "Add a new modification for the drawing",
    "nameLabel": "Modification name",
    "namePlaceholder": "883.60",
    "continue": "Continue",
    "created": "Modification “{{name}}” added",
    "renamed": "Modification renamed",
    "deleted": "“{{name}}” deleted",
    "deleteTitle": "Delete modification",
    "deleteText": "“{{name}}” and its drawing and indicators will be deleted.",
    "deleteError": "Could not delete the modification",
    "defaultNoDelete": "The main folder cannot be deleted",
    "limit": "Folder limit reached ({{max}})",
    "unsaved": "Unsaved changes",
    "pinCount_one": "{{count}} indicator",
    "pinCount_other": "{{count}} indicators",
    "menu": {
      "rename": "Edit",
      "replace": "Replace drawing",
      "delete": "Delete"
    },
    "errors": {
      "required": "Enter the modification name",
      "tooLong": "The name must not exceed {{max}} characters",
      "taken": "A folder with this name already exists",
      "generic": "Could not save"
    }
  },
  "rail": {
    "label": "Layers",
    "drawing": "Drawing",
    "deviceInfo": "Device info",
    "data": "Database",
    "table": "Table",
    "state": {
      "uploaded": "uploaded",
      "notUploaded": "not uploaded",
      "enabled": "enabled",
      "disabled": "disabled",
      "configured": "configured",
      "notConfigured": "not configured"
    }
  },
  "canvas": {
    "label": "Drawing area",
    "drawing": "Drawing and indicators",
    "roleDescription": "drawing editor",
    "emptyTitle": "No drawing uploaded",
    "emptyText": "Upload a drawing file to this folder to get started.",
    "upload": "Upload drawing",
    "placingHint": "Pick a spot on the drawing (cancel: Esc)",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "fit": "Fit (100%)",
    "dropHere": "Drop the drawing file here"
  },
  "drawing": {
    "emptyTitle": "No drawing uploaded",
    "emptyText": "No drawing yet. Click \"Upload drawing\" and choose an SVG, PNG or DWG file.",
    "opacity": "Opacity",
    "scale": "Scale",
    "replace": "Replace drawing",
    "delete": "Delete drawing",
    "deleteTitle": "Delete drawing",
    "deleteText": "The drawing is removed from the folder. Indicators stay in place and reappear when a new drawing is uploaded.",
    "deletePinsToo_one": "Also delete the indicator ({{count}})",
    "deletePinsToo_other": "Also delete the indicators ({{count}})",
    "uploading": "Uploading… {{progress}}%",
    "uploaded": "Drawing uploaded",
    "replaced": "Drawing replaced",
    "saveHint": "Don't forget to save your changes",
    "uploadError": "Could not read the file",
    "typeError": "This file type is not accepted",
    "sizeError": "The file is too large",
    "formats": "SVG, PNG, JPG or WEBP · up to 50 MB",
    "dwgTitle": "DWG conversion is not available yet",
    "dwgText": "Export the drawing to SVG or PNG and upload it.",
    "aspectChanged": "The drawing's aspect ratio changed — check the indicator positions"
  },
  "pins": {
    "title": "Indicators",
    "add": "Add indicator",
    "cancelPlacing": "Cancel placement",
    "emptyTitle": "No indicators",
    "emptyText": "No indicators yet. Click \"Add indicator\" and pick a spot on the drawing.",
    "needDrawing": "Upload a drawing first",
    "needDrawingHint": "Indicators are placed on top of the drawing",
    "limit": "Indicator limit reached ({{max}})",
    "untitled": "New indicator",
    "noDevice": "No device selected",
    "rows_one": "{{count}} reading",
    "rows_other": "{{count}} readings",
    "show": "{{name}} — show",
    "hide": "{{name}} — hide",
    "hiddenHint": "Hidden on the view page",
    "visibleHint": "Visible on the view page",
    "settings": "{{name}} settings",
    "delete": "{{name}} — delete"
  },
  "pin": {
    "back": "Go back",
    "title": "Device settings",
    "device": "DEVICE",
    "devicePlaceholder": "Select a device",
    "dynamic": "Dynamic - comes from the device: {{value}}",
    "rows": "ROWS (NAME = VALUE)",
    "rowName": "Row {{index}} name",
    "rowNamePlaceholder": "Name ({{suffix}})",
    "rowNamePlain": "Name",
    "rowSource": "Row {{index}} value source",
    "rowValue": "Row {{index}} value",
    "rowValuePlaceholder": "Value (0.45 mm)",
    "removeRow": "Delete row {{index}}",
    "manual": "Manual entry...",
    "addRow": "Add row",
    "rowsLimit": "At most {{max}} rows",
    "rowsHint": "Pick the value from a device indicator or type it in.",
    "addSensorRow": "Device",
    "labelPlacement": "LABEL PLACEMENT",
    "side": {
      "top": "Top",
      "right": "Right",
      "bottom": "Bottom",
      "left": "Left"
    },
    "distance": "DISTANCE FROM POINT",
    "offsetVertical": "SHIFT UP / DOWN",
    "offsetHorizontal": "SHIFT LEFT / RIGHT",
    "hint": "The point stays in place - only the label card moves. The point size does not change.",
    "delete": "Delete device",
    "deleteTitle": "Delete device",
    "deleteText": "“{{code}}” will be removed from the drawing and the 3D model.",
    "deleted": "“{{code}}” deleted",
    "undoHint": "Undo: Ctrl+Z"
  },
  "picker": {
    "placeholder": "Select",
    "search": "Search for a device or reading",
    "loading": "Loading devices…",
    "empty": "Nothing found",
    "missing": "Device not found",
    "otherCategory": "Other devices"
  },
  "layers": {
    "showInViewer": "Show on the view page"
  },
  "deviceInfo": {
    "title": "Device information",
    "enabledHint": "Enabled - the \"Device information\" button is shown",
    "disabledHint": "Disabled - not shown on the view page",
    "name": "Name",
    "namePlaceholder": "Enter the device name",
    "media": "Images and video",
    "mediaTitle": "Upload an image or video",
    "mediaHint": "JPG, PNG, MP4 · up to 50 MB",
    "addMedia": "Add an image or video",
    "removeMedia": "{{name}} — remove",
    "cover": "cover",
    "mediaLimit": "At most {{max}} images or videos",
    "typeError": "Only JPG, PNG, WEBP images or MP4, WEBM videos",
    "sizeError": "The file must not exceed 50 MB",
    "uploadError": "Could not upload the file",
    "collage": "Collage style",
    "grid": "Grid",
    "mosaic": "Mosaic",
    "carousel": "Strip",
    "collagePreview": "Collage preview",
    "previous": "Previous",
    "next": "Next",
    "description": "Description",
    "editorName": "Professional editor",
    "descriptionPlaceholder": "Describe the device in detail…",
    "textEmpty": "Text is empty",
    "textBlocks_one": "Text · {{count}} block",
    "textBlocks_other": "Text · {{count}} blocks",
    "limitReached": "The text must not exceed {{max}} characters",
    "linkInvalid": "Invalid link (http, https, mailto or tel)",
    "pdf": "PDF download",
    "pdfOff": "Disabled - when enabled, a PDF button is shown",
    "pdfOn": "Enabled - users can download a PDF"
  },
  "rte": {
    "toolbar": "Text formatting",
    "blockType": "Block type",
    "size": "Text size",
    "paragraph": "Paragraph",
    "heading1": "Heading 1",
    "heading2": "Heading 2",
    "quote": "Quote",
    "codeBlock": "Code block",
    "undo": "Undo",
    "redo": "Redo",
    "bold": "Bold",
    "italic": "Italic",
    "underline": "Underline",
    "color": "Text colour",
    "bullets": "Bulleted list",
    "numbers": "Numbered list",
    "checklist": "Checklist",
    "link": "Link",
    "linkUrl": "Link address",
    "applyLink": "Add",
    "unlink": "Remove",
    "alignLeft": "Align left",
    "alignCenter": "Centre",
    "alignRight": "Align right",
    "alignJustify": "Justify",
    "table": "Insert table",
    "image": "Insert image",
    "code": "Code",
    "clear": "Clear formatting"
  },
  "data": {
    "enabledHint": "Enabled - the \"Device chart\" panel is shown",
    "disabledHint": "Disabled - not shown on the view page",
    "name": "Title",
    "namePlaceholder": "Device chart",
    "series": "Devices",
    "addSeries": "Add device",
    "seriesLimit": "At most {{max}} devices",
    "removeSeries": "{{name}} — remove",
    "color": "Line colour",
    "axis": "Axis",
    "left": "Left",
    "right": "Right",
    "range": "Default period",
    "range1d": "1 DAY",
    "range7d": "7 DAYS",
    "range30d": "30 DAYS",
    "rangeAll": "All",
    "view": "View",
    "viewChart": "As a chart",
    "viewTable": "As a table",
    "thresholds": "Thresholds",
    "thresholdLabel": "Threshold name",
    "thresholdLabelPlaceholder": "Warning 25 °C",
    "thresholdValue": "Value",
    "thresholdKind": "Threshold type",
    "warning": "Warn.",
    "danger": "Danger",
    "addThreshold": "Add threshold",
    "removeThreshold": "Delete threshold"
  },
  "tableLayer": {
    "enabledHint": "Enabled - the \"Table\" panel is shown",
    "disabledHint": "Disabled - not shown on the view page",
    "name": "Title",
    "namePlaceholder": "Table",
    "mode": "Table type",
    "deviceList": "Device list",
    "custom": "Custom table",
    "deviceListHint_one": "Readings of the devices on the drawing are listed automatically · now {{count}} row.",
    "deviceListHint_other": "Readings of the devices on the drawing are listed automatically · now {{count}} rows.",
    "openConstructor": "Table builder"
  },
  "table": {
    "title": "Table builder",
    "fullscreen": "Full screen",
    "exitFullscreen": "Exit full screen",
    "name": "Table name",
    "namePlaceholder": "Monitoring by section line",
    "untitled": "Untitled table",
    "columnsAndRows": "Columns and rows",
    "columns": "Columns (section lines)",
    "columnsRange": "from {{min}} to {{max}}",
    "addColumn": "Add column",
    "removeColumn": "Remove column",
    "rows": "Rows",
    "noRows": "No rows",
    "count": {
      "manual": "manual {{n}}",
      "device": "device {{n}}",
      "formula": "formula {{n}}",
      "status": "status {{n}}"
    },
    "addRow": "Add row",
    "addRowHint": "Click a type - the row is added immediately",
    "rowType": {
      "manual": "Manual",
      "device": "Device",
      "formula": "Formula",
      "status": "Status"
    },
    "defaultRowName": "Row {{n}}",
    "rowLimit": "At most {{max}} rows",
    "formula": "Formula",
    "formulaPlaceholder": "No cell selected - formula or value",
    "usesRowFormula": "Row formula: {{formula}}",
    "statusAuto": "The status cell is calculated automatically",
    "pickSensor": "Choose the reading for the cell",
    "grid": "Table",
    "size": "{{rows}} rows · {{cols}} columns",
    "cornerLabel": "Section line no.",
    "columnLabel": "Column {{index}} name",
    "editCell": "Cell value",
    "emptyRows": "Click one of the buttons above to add a row",
    "untitledRow": "Untitled row",
    "formulaError": "Error",
    "settings": "Settings",
    "rowSettingsTab": "Row settings",
    "statusesTab": "Statuses",
    "discardTitle": "Table changes are not saved",
    "discardText": "If you close the window, the changes to the table will be discarded.",
    "discard": "Discard and close",
    "keepEditing": "Keep editing",
    "rowSettings": {
      "none": "No row selected — click a row header or a cell in the table.",
      "name": "Row name",
      "type": "Type",
      "manualHint": "Enter values in the table cells (double-click or Enter).",
      "sensors": "Readings per column",
      "sensorFor": "Column {{column}} reading",
      "rowFormula": "Apply to all columns",
      "formulaHint": "R1…Rn — row values, C — column number, X — value of the device above. A formula in a cell takes precedence.",
      "source": "Source row",
      "sourceNone": "Nearest device row",
      "sourceHint": "The status is derived from this row's value using the statuses.",
      "up": "Move up",
      "down": "Move down",
      "delete": "Delete row"
    },
    "status": {
      "title": "Status thresholds",
      "byValue": "By device value",
      "empty": "No statuses added yet",
      "range": "Range:",
      "rangeFrom": "above {{value}}",
      "rangeTo": "up to {{value}}",
      "rangeAll": "All values",
      "add": "Add status",
      "autoColor": "Change the cell colour automatically",
      "edit": "{{name}} — edit",
      "delete": "{{name}} — delete",
      "back": "Back to statuses",
      "addTitle": "New status",
      "editTitle": "Edit status",
      "new": "New",
      "name": "Name",
      "namePlaceholder": "For example: Important",
      "note": "Note",
      "notePlaceholder": "Write a short note",
      "color": "Colour",
      "colors": {
        "1ECD15": "Green",
        "0275FF": "Blue",
        "F48200": "Orange",
        "CA3B3D": "Red",
        "99A3B8": "Grey"
      },
      "limits": "Range (device value)",
      "from": "from",
      "to": "to",
      "fromLabel": "Lower limit (from)",
      "toLabel": "Upper limit (to)",
      "addButton": "Add",
      "deleteButton": "Delete status",
      "deleteConfirm": "Delete the status?",
      "deleteUsed_one": "The status is used in {{count}} status row. Delete anyway?",
      "deleteUsed_other": "The status is used in {{count}} status rows. Delete anyway?",
      "errors": {
        "name": "Enter the status name",
        "nameTaken": "A status with this name already exists",
        "number": "The limit must be a number",
        "order": "The \"from\" value must be less than \"to\"",
        "overlap": "The range overlaps another status"
      }
    }
  },
  "scene": {
    "canvas": "3D map",
    "globeNotice": "The 3D globe (CesiumJS) is not connected yet. The model, placement and devices are saved.",
    "needsGlobe": "Works once the 3D globe is connected",
    "search": "Search place",
    "searchPlaceholder": "Coordinates: 41.5521, 69.9654",
    "searchGo": "Go to place",
    "searchHint": "Enter coordinates, for example: 41.5521, 69.9654",
    "searchRange": "Invalid coordinates",
    "attribution": "Map not connected · {{lat}}, {{lng}} · {{height}} m",
    "tools": {
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "north": "Reset north",
      "baseMap": "Base map",
      "rotate": "Rotate",
      "scale": "Scale",
      "flyTo": "Fly to object",
      "measure": "Measure"
    },
    "emptyTitle": "No 3D object uploaded",
    "emptyText": "Upload a 3D model of the dam in GLB or glTF format. Then place it on the map.",
    "dropHere": "Drop the GLB file here",
    "or": "or",
    "pickFile": "Choose file",
    "formats": "Format: .glb, .gltf (embedded textures) · max. 100 MB",
    "objTitle": "OBJ conversion is not available yet",
    "objText": "Export the model to GLB or glTF and upload it.",
    "typeError": "This file type is not accepted",
    "sizeError": "The file must not exceed 100 MB",
    "uploadError": "Could not upload the model",
    "uploaded": "3D model uploaded",
    "loadError": "Could not load the 3D scene",
    "model": "3D object",
    "replace": "Replace model",
    "delete": "Delete model",
    "deleteTitle": "Delete the 3D object",
    "deleteText": "The model is removed from the scene. The placement and device anchors are kept.",
    "status": {
      "ready": "Ready",
      "processing": "Processing…",
      "failed": "Could not read the file"
    },
    "placement": "Placement",
    "lat": "Latitude",
    "lng": "Longitude",
    "height": "Height",
    "heading": "Heading",
    "scale": "Scale",
    "clamp": "Clamp to terrain",
    "coordInvalid": "For example: 41.5521 or 41.5521° N",
    "devices": "Devices",
    "searchDevices": "Search devices",
    "pinnedDevices": "Devices on the drawings",
    "noDevices": "No device-bound indicators on the drawings",
    "noMatches": "Nothing found",
    "dragging": "Dragging…",
    "dragHint": "Drag a device onto the 3D object or press the button.",
    "needModel": "Upload a 3D model first",
    "needModelHint": "Upload a 3D model first to attach devices.",
    "attach": "Attach to the model centre",
    "attached": "Attached to the model",
    "attachDevice": "{{name}} — attach to the model",
    "detachDevice": "{{name}} — detach from the model",
    "notPlaced": "Not attached to the model",
    "showAnchor": "{{name}} — show",
    "hideAnchor": "{{name}} — hide"
  }
}
